export default "__VITE_ASSET__BsZ0Yjpg__"